/**
 * [ File :: B_Real ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/child/base/B_Real.js
 * @목적 : 보이는 객체를 처리하는 최상위 객체
 * @진행 : 개발종료
 * @주의 : 'createjs-contrainer' 객체를 필드로 가지고 있습니다. (_container)
 * @이슈 : '_setArea & _setPoint' 를 객체가 전달되기 전에 생성자에서 처리하고 싶은데, 상속받는클래스가 얼마나 많아질지 몰라 객체를 생성한 후에 사용자가 직접 호출해줘야함.
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 : 'createjs-container' 개념필요
 */

// [Base] 관련
import B_Util from 'canvas/base/dev/util/B_Util';
import B_Define from 'canvas/base/dev/util/B_Define';
import B_Child from 'canvas/base/dev/child/base/B_Child';

const B_Real = (function () {

	// [V]
	const $ = {
		_isExist: null,    // 존재 {bool}
		_grid: null,       // 부모그리드 {str}
		_container: null,  // 컨테이너 {obj}
		_res: null,        // 리소스 {str}
		_strResType: null, // 리소스 타입 {str}
		_object: null,     // 객체 {obj}
		_w: null,          // 가로 {num}
		_h: null,          // 세로 {num}
		_regX: null,       // 등록점 X {num}
		_regY: null,       // 등록점 Y {num}
		_visible: null,    // 보임 {bool}
		_color: null,      // 색상 {str}
		_arrAnimate: null  // 애니메이션 {arr}
	};

	// /**
	//  * @DES :: arrAnimate {arr} - 객체에 포함된 애니메이션 객체 (여러 형식의 애니메이션을 넣을 수 있습니다.)
	//  * @E.X :: [
	//  *   {
	//  *       type  : "proton",
	//  *       value : emitter
	//  *   },
	//  *   {
	//  *       type  : "tween",
	//  *       value : tween
	//  *   }
	//  * ]
	//  */

	class B_Real extends B_Child {

		constructor(obj) {
			super(obj);
			// /*[T] 지우지 마세요.*/ console.log(obj);

			// [S] isExist, container
			this._isExist = true; // 존재
			this._container = new createjs.Container(); // [#] container
			this._container.type = obj.type; // [#] container-type 처리 (필수)

			// [E] obj.visible
			if (typeof obj.visible === 'undefined') this._visible = true; // default == true

			if (obj.res) {
				if (typeof this.CODMOS._res[obj.res] == 'undefined') {
					// [E] res를 참조해야하는데... 참조할 리소스가 없는디 ???
					B_Util.print(B_Define.MESSAGE['NO_CHILD_RES'] + obj.res);
					return;
				}
				else {
					// [E] res 참조속성처리
					obj.w = this._checkRes(obj.w, this.CODMOS._res[obj.res].w, 0);
					obj.h = this._checkRes(obj.h, this.CODMOS._res[obj.res].h, 0);
					obj.pointX = this._checkRes(obj.pointX, this.CODMOS._res[obj.res].pointX, undefined);
					obj.pointY = this._checkRes(obj.pointY, this.CODMOS._res[obj.res].pointY, undefined);

					// [S] res
					this._res = obj.res;                   // [*] res 저장
				}
			}

			// [E] obj.x, obj.y
			if (typeof obj.x == 'undefined') obj.x = 0;   // X좌표 (안보임 처리)
			if (typeof obj.y == 'undefined') obj.y = 0;   // Y좌표 (안보임 처리)


			// [S] 논리 데이터
			this._arrAnimate = [];

			// [S] 물리 데이터
			// [#] area(w, h)와 point(reg)를 실제 적용하는 것은 하위 클래스에서 각각 설정값을 만족한 후 입니다.
			if (typeof obj.x !== "undefined") this._pixelX = obj.x;
			if (typeof obj.y !== "undefined") this._pixelY = obj.y;
			if (typeof obj.w !== "undefined") this._w = obj.w;
			if (typeof obj.h !== "undefined") this._h = obj.h;
			if (typeof obj.pointX !== "undefined") this._pointX = obj.pointX;
			if (typeof obj.pointY !== "undefined") this._pointY = obj.pointY;
			if (typeof obj.color !== "undefined") this._color = obj.color;
		}

		// [V] public

		// @DES ::
		get pixelX() { return this._pixelX; }
		get pixelY() { return this._pixelY; }

		// [V] protected

		// @DES :: visible {bool} - 보임 여부
		get _visible() { return this._container.visible; }
		set _visible(v) { this._container.visible = v; }

		// @DES :: x {num} - 활성화 여부 */
		get _pixelX() { return this._container.x; }
		set _pixelX(x) { this._container.x = x; }

		// @DES :: y {num} - 활성화 여부 */
		get _pixelY() { return this._container.y; }
		set _pixelY(y) { this._container.y = y; }

		// @DES :: regX {num} - 활성화 여부 */
		get _regX() { return this._container.regX; }
		set _regX(rx) { this._container.regX = rx; }

		// @DES :: regY {num} - 활성화 여부 */
		get _regY() { return this._container.regY; }
		set _regY(ry) { this._container.regY = ry; }

		// @DES :: scaleX {num} - 활성화 여부 */
		get _scaleX() { return this._container.scaleX; }
		set _scaleX(sx) { this._container.scaleX = sx; }

		// @DES :: scaleY {num} - 활성화 여부 */
		get _scaleY() { return this._container.scaleY; }
		set _scaleY(sy) { this._container.scaleY = sy; }

		// @DES :: Alpha {num} - 투명도 여부
		get _alpha() { return this._container.alpha; }
		set _alpha(a) { this._container.alpha = a; }

		// @DES :: rotation {num} - 회전
		get _rotation() { return this._container.rotation; }
		set _rotation(r) { this._container.rotation = r; }

		// [F] protected

		/**
		 * @DES :: 활성 여부 토글 함수
		 * @S.E :: 자신의 active를 참조해서 토글합니다.
		 */
		_toggleActive() {
			this._active = !this._active;
		}

		/**
		 * @DES ::
		 * @IP1 ::
		 * @S.E ::
		 */
		_setActiveAnimate(a) {
			this._active = a;
			this._playAndStopAnimate(a);
		}

		/**
		 * @DES :: LC용 충돌테스트 :: object(in container) vs object(in container)
		 * @IP1 :: x {num}
		 * @IP2 :: y {num}
		 * @OUP :: rtn {bool}
		 * @S.E :: 컨테이너 충돌을 비교할 때는, 제공되는 'hitTest'가 아닌 다음 메소드를 사용하세요.
		 */
		_LChitTest(x, y) {
			let rtn, obj = this._object;
			obj.x = this.getX();
			obj.y = this.getY();   // [#] 내부 object 위치를 컨테이너 위치로 임시 이동합니다..
			rtn = this.hitTest(x, y);
			obj.x = 0;
			obj.y = 0;                       // [#] 내부 object 위치를 원위치합니다.
			return rtn;
		}

		/**
		 * @DES :: 속성이 없다면 res를 참조해서 대체합니다.
		 * @IP1 :: inProp {none}
		 * @IP2 :: resProp {none}
		 * @IP2 :: defaultProp {none}
		 * @O.P :: prop {none}
		 * @S.E ::
		 */
		_checkRes(inProp, resProp, defaultProp) {
			if (typeof inProp === 'undefined') {
				// [#] 만약 리소스를 참조하는 객체일때, (리소스를 참조하지 않는 객체로 있습니다.)
				if (typeof resProp !== 'undefined') return resProp;
				else return defaultProp;
			}
			else return inProp;
		}

		/**
		 * @DES :: 요청하는 w, h를 설정하는 함수, 없다면 기존의 값으로 유지
		 * @IP1 :: w {num}
		 * @IP2 :: h {num}
		 * @O.P :: null
		 * @S.E :: 요청 width, height 가 있다면 요청 값으로 처리하고 없다면 area 값으로 처리합니다.
		 */
		_checkArea(w, h) {
			if (this._object) {
				if (typeof w == 'number' && typeof h == 'number') {
					this._w = w;
					this._h = h;
					return true;
				}
				else if (typeof this._w == 'number' && typeof this._h == 'number') {
					return true;
				}
				else return false;
			}
			else return false;
		}

		/**
		 * @DES :: 요청하는 regX, regY를 설정하는 함수, 없다면 기존의 값으로 유지
		 * @IP1 :: px {num} - 넓이에서 어디에 위치 시킬 것인지 (좌(0)~우(100)) :: 50이 중간
		 * @IP2 :: py {num} - 높이에서 어디에 위치 시킬 것인지 (상(0)~하(100)) :: 50이 중간
		 * @S.E ::
		 */
		_checkReg(px, py) {
			if (this._object) {
				if (typeof px == 'number' && typeof py == 'number') {
					this._pointX = px;
					this._pointY = py;
					return true;
				}
				else if (typeof this._pointX == 'number' && typeof this._pointY == 'number') {
					return true;
				}
				else return false;
			}
			else return false;
		}

		// @OVERRIDING
		_remove() {
			super._remove();

			/**
			 * [ STEP ]
			 *
			 * 01. 안보임(활성화포함) 처리
			 * */

			this._visible = false;
		}

		/**
		 * @DES :: 객체 보임여부 토글 처리 (활성화 여부까지 같이 동작)
		 * @S.E :: _visible, _active 동작
		 */
		_toggleVisible() {
			if (this._visible) {
				this._visible = false;
			}
			else {
				this._visible = true;
			}
		}

		/**
		 * @DES :: 필터제작함수
		 * @IP1 :: obj {obj}
		 * @IP2 :: filters {arr}
		 * @IP3 :: originWidth {num}
		 * @IP4 :: originHeight {num}
		 * @IP5 :: width {num}
		 * @IP6 :: height {num}
		 * @IP7 :: pointX {num}
		 * @IP8 :: pointY {num}
		 * @O.P :: filterObj {obj}
		 * @S.E ::
		 */
		_makeFilter(obj, filters, originWidth, originHeight, width, height, pointX, pointY) {
			let filteredObj = obj.clone();
			filteredObj.filters = filters;
			filteredObj.cache(0, 0, originWidth, originHeight);
			filteredObj.scaleX = width / originWidth;
			filteredObj.scaleY = height / originHeight;
			filteredObj.regX = originWidth * pointX / 100;
			filteredObj.regY = originHeight * pointY / 100;
			filteredObj.alpha = 0;
			return filteredObj;
		}

		/**
		 * @DES :: 애니메이션 Play and Stop 함수
		 * @IP1 :: active {bool}
		 * @S.E ::
		 */
		_playAndStopAnimate(active) {
			// /*[T]*/ console.log('_playAndStopAnimate call', active);

			if (active) {
				// [#] 연결된 애니메이션 활성화
				this._arrAnimate.forEach((v) => {
					switch (v.type) {
						case "proton" :
							v.value.emit();
							break;
						case "tween" :
							break;
					}
				});
			}
			else {
				// [#] 연결된 애니메이션 비활성화
				this._arrAnimate.forEach((v) => {
					switch (v.type) {
						case "proton" :
							v.value.stopEmit();
							break;
						case "tween" :
							break;
					}
				});
			}
		}

		// @INTERPACE
		_setArea() { }

		// @INTERPACE
		_setPoint() { }

		// @INTERPACE
		_getOriginWidth() { }

		// @INTERPACE
		_getOriginHeight() { }

	};

	B_Util.manageGetAndSet(B_Real, $);
	return B_Real;
}());

export default B_Real;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/base/B_Real.js